// src/components/invoices/InvoiceStatusChip.jsx
import { Chip } from '@mui/material';
import { getInvoiceStatusColor, getInvoiceStatusLabel } from 'utils/statusHelpers';

const InvoiceStatusChip = ({ status }) => {
  return <Chip label={getInvoiceStatusLabel(status)} color={getInvoiceStatusColor(status)} size="small" />;
};

export default InvoiceStatusChip;
